/* =========================================================
   Plantive Goals - JS (Optimized for Shopify 2.0 & Apple Style)
========================================================= */

document.addEventListener('DOMContentLoaded', () => {
  const goalSections = document.querySelectorAll('.section-plantive-goals:not(.js-loaded)');

  goalSections.forEach(section => {
    section.classList.add('js-loaded');
    
    // --- 🍎 Apple Fade-up Observer ---
    const observer = new IntersectionObserver((entries, obs) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          obs.unobserve(entry.target); 
        }
      });
    }, { threshold: 0.15 }); 
    observer.observe(section);

    // --- Swiper.js Initialization (Mobile Only) ---
    const swiperContainer = section.querySelector('.pg-swiper');
    if (!swiperContainer) return;

    const configSlides = parseFloat(swiperContainer.dataset.slides) || 1.1;
    const configLoop = swiperContainer.dataset.loop === 'true';

    // 💡 รอจนกว่าไฟล์ Swiper กลางจะโหลดเสร็จ (ลดการโหลดไฟล์ซ้ำซ้อน)
    function initSwiper() {
      if (typeof Swiper === 'undefined') {
        setTimeout(initSwiper, 100);
        return;
      }

      new Swiper(swiperContainer, {
        centeredSlides: true, 
        loop: configLoop, 
        speed: 800, // Smooth speed
        grabCursor: true,
        
        navigation: {
          nextEl: section.querySelector('.pg-next'),
          prevEl: section.querySelector('.pg-prev'),
        },
        
        pagination: {
          el: section.querySelector('.pg-swiper-pagination'),
          clickable: true,
        },

        breakpoints: {
          0: {
            slidesPerView: configSlides, 
            spaceBetween: 16,
            enabled: true
          },
          991: {
            enabled: false, 
            spaceBetween: 24
          }
        }
      });
    }

    initSwiper();
  });
});

// Re-init on Shopify Editor
document.addEventListener('shopify:section:load', () => {
   window.dispatchEvent(new Event('DOMContentLoaded'));
});